// =============================================
// useTokenCheck — stan UI nad runTokenCheck (kroki na zywo + podsumowanie).
// Uzywany przez TokenCheckDialog ("Sprawdz token" przy koncie) i przez dialog
// edycji konta (test nowego tokena przed zapisem).
// =============================================
import { useCallback, useState } from "react";
import { runTokenCheck, TOKEN_CHECK_STEPS, type TokenCheckStep, type TokenCheckSummary } from "@/services/cloudflare/tokenCheck";

const initialSteps = (): TokenCheckStep[] => TOKEN_CHECK_STEPS.map((s) => ({ ...s, status: "running", message: "" }));

export function useTokenCheck() {
  const [steps, setSteps] = useState<TokenCheckStep[] | null>(null);
  const [summary, setSummary] = useState<TokenCheckSummary | null>(null);
  const [running, setRunning] = useState(false);

  const run = useCallback(async (acc: { api_token: string; account_id?: string | null }) => {
    setRunning(true);
    setSummary(null);
    setSteps(initialSteps());
    try {
      const res = await runTokenCheck(acc, (step) => {
        setSteps((prev) => (prev ? prev.map((s) => (s.id === step.id ? step : s)) : prev));
      });
      setSummary(res);
      return res;
    } finally {
      setRunning(false);
    }
  }, []);

  const reset = useCallback(() => { setSteps(null); setSummary(null); }, []);

  return { steps, summary, running, run, reset };
}
